import React from 'react';
import { BsFillBookmarkCheckFill, BsFillBookmarkStarFill, BsInfoSquareFill } from 'react-icons/bs';
import { FaMapMarkerAlt, FaUserPlus } from 'react-icons/fa';
import { MdOutlinePostAdd, MdReviews } from 'react-icons/md';
import { Link, useParams } from 'react-router-dom';
import useUserById from '../../hooks/useUserById';
import Navbar from '../Shared/Navbar';
import { auth } from '../../firebase.init';
import { useAuthState } from 'react-firebase-hooks/auth';
import { BiEdit } from 'react-icons/bi';
import { HiMail } from 'react-icons/hi';
import { TbFileInfo, TbLanguage } from 'react-icons/tb';
import MyPosts from './MyPosts';

const Profile = () => {

    const { id } = useParams();
    const [userq] = useUserById(id);

    const [user, loading] = useAuthState(auth);

    //console.log(userq);

    return (
        <div>
            <Navbar />
            {
                loading || userq === null ? (
                    <h1 className='min-h-screen text-4xl my-8 text-yellow-500'>Loading...</h1>
                ) : (
                    <div className='w-11/12 mx-auto min-h-screen py-16'>
                        <div className='lg:flex'>
                            <div className='w-11/12 lg:w-1/3 p-4'>
                                <img className='w-1/2 block rounded-lg' src={userq?.img} alt="profile picture" />
                                <h2 className='mt-5 mb-1 text-2xl font-extrabold'>{userq?.name}</h2>
                                {
                                    user?.email === userq?.email ? (
                                        <Link to='/editprofile' className='inline-block bg-yellow-500 rounded-md px-4 py-1 mb-6'>
                                            <div className='flex items-center justify-center md:justify-start text-white'>
                                                <BiEdit className='' />
                                                <p className='font-medium px-2'>Edit Profile</p>
                                            </div>
                                        </Link>
                                    ) : (
                                        <Link className='inline-block bg-yellow-500 rounded-md px-4 py-1 mb-6'>
                                            <div className='flex items-center text-white'>
                                                <FaUserPlus className='' />
                                                <p className='font-medium px-2'>Follow</p>
                                            </div>
                                        </Link>
                                    )
                                }
                                {
                                    userq?.noRating === 0 ? (
                                        <div className='flex items-center justify-center md:justify-start mt-2 mb-4'>
                                            <BsFillBookmarkStarFill className='text-yellow-500' />
                                            <p className='font-semibold px-1 capitalize'>New {userq?.role}</p>
                                        </div>
                                    ) : (
                                        <div>
                                            <div className='flex items-center justify-start mt-2 mb-4'>
                                                <BsFillBookmarkStarFill className='text-yellow-500' />
                                                <p className='font-semibold px-1'>{userq?.rating}</p>
                                                <MdReviews className='ml-8 text-yellow-500' />
                                                <p className='font-medium px-1'>{userq?.noRating}+ reviews</p>
                                            </div>
                                            <div className='flex items-center justify-start mt-2 mb-4'>
                                                <BsFillBookmarkCheckFill className='text-yellow-500' />
                                                <p className='font-semibold px-1 capitalize'>{userq?.noTour}  Tours  Completed</p>
                                            </div>
                                        </div>
                                    )
                                }
                                <h2 className='mt-5 mb-1 text-xl font-extrabold'>Contact Info</h2>
                                <div className='flex items-center justify-start text-gray-500'>
                                    <HiMail />
                                    <p className='pl-2 font-semibold'>{userq?.email}</p>
                                </div>
                                <h2 className='mt-5 mb-1 text-xl font-extrabold'>Location</h2>
                                <div className='flex items-center justify-start text-gray-500'>
                                    <FaMapMarkerAlt />
                                    <p className='pl-2 font-semibold capitalize'>{userq?.city}, {userq?.division}</p>
                                </div>
                            </div>
                            <div className='w-11/12 lg:w-2/3 p-4'>
                                <div className='shadow-2xl rounded-2xl p-8'>
                                    <div className='flex items-center mb-4 text-xl text-gray-500'>
                                        <TbFileInfo className='' />
                                        <h2 className='font-bold ml-2'>About Me</h2>
                                    </div>
                                    {
                                        userq?.bio?.length === 0 ? (
                                            <div className='text-lg'>
                                                Hi, I am <span className='font- text-yellow-500'>{userq?.name}</span> from {userq?.city}, {userq?.division}.
                                            </div>
                                        ) : (
                                            <div>
                                                {userq?.bio}
                                            </div>
                                        )
                                    }
                                    <div className='flex items-center mb-4 text-xl text-gray-500 mt-6'>
                                        <TbLanguage className='' />
                                        <h2 className='font-bold ml-2'>Speaks - </h2>
                                        <div className='text-lg font-semibold ml-3'>
                                            {userq?.speaks}
                                        </div>
                                    </div>
                                </div>
                                <div className='shadow-2xl rounded-2xl p-8 my-16'>
                                    <div className='flex items-center mb-4 text-xl text-gray-500'>
                                        <MdOutlinePostAdd className='' />
                                        <h2 className='font-bold ml-2'>Timeline</h2>
                                    </div>
                                    <MyPosts key={userq?._id} id={userq?._id} />
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        </div>
    );
};

export default Profile;